<template>
  <LegalPage />
</template>
